export const ACCOUNT_FIELD = "account";
export const BUSINESS_ID_FIELD = "businessId";
export const SPECIAL_SERVICE_EXCLUSIONS_FIELD = "specialServices";
export const QUEUE_TYPE_FIELD = "queueType";
export const BULK_ACCOUNTS_FIELD = "accounts";
export const QUEUE_TYPES = {
  NONE: "",
  ELITE: "Elite",
  PLATINUM: "Platinum",
};
export const CHAT_QUEUE_TYPES = [QUEUE_TYPES.ELITE, QUEUE_TYPES.PLATINUM];
export const MAX_BULK_CHAT_QUEUE_ACCOUNTS = 1000;
export const CHAT_QUEUE_ACCOUNTS_PAGE_SIZE = 10;
export const CUSTOMER_SETTINGS_ERRORS = {
  ACCOUNT_WAS_NOT_FOUND: "Account was not found",
  ACCOUNT_WAS_NOT_FOUND_FOR_DPD: 'Account was not found for business ID "DPD" ',
  ACCOUNT_WAS_NOT_FOUND_FOR_DPD_LOCAL:
    'Account was not found for business ID "DPD LOCAL" ',
};
export const SEARCH_FORM_ERRORS = {
  MISSING_ACCOUNT: "Please enter logon ID or account",
};
export const CHAT_QUEUE_FORM_ERRORS = {
  MISSING_QUEUE_TYPE: "Please select a queue type",
  MISSING_ACCOUNTS: "Please enter at least one account number",
  INVALID_ACCOUNTS: "Account numbers must be 6 or 7 digits",
  TOO_MANY_ACCOUNTS: "You can add up to 1000 account numbers",
};
